import { SVGProps } from '@components/Icon/types';

export const MoreCircleFilled = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM6 11C5.44 11 5 10.55 5 10C5 9.45 5.45 9 6 9C6.55 9 7 9.45 7 10C7 10.55 6.56 11 6 11ZM10 11C9.44 11 9 10.55 9 10C9 9.45 9.45 9 10 9C10.55 9 11 9.45 11 10C11 10.55 10.56 11 10 11ZM14 11C13.44 11 13 10.55 13 10C13 9.45 13.45 9 14 9C14.55 9 15 9.45 15 10C15 10.55 14.56 11 14 11Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'more-circle-filled';
